import { useToast } from 'primevue/usetoast';
import { logger } from '@tools/logging';

export const useNotification = () => {
  try {
    const toast = useToast();

    const success = (message: string, indefinite = false) => {
      toast.add({ severity: 'success', detail: message, life: indefinite ? undefined : 3000 });
    };

    const error = (message: string) => {
      toast.add({ severity: 'error', detail: message });
    };

    return {
      success,
      error,
    };
  } catch (error) {
    // dit komt voor als de notification buiten een setup functie wordt gebruikt.
    logger.warn('Error initializing toast', error);
    return {
      success: (message: string) => console.error('Unsent success toast:', message),
      error: (message: string) => console.error('Unsent error toast:', message),
    };
  }
};
